export const enum BizTypeMenu {
  SYS_MENU_LIST = 'SYS_MENU_LIST',
  SYS_MENU_LIST_TREE = 'SYS_MENU_LIST_TREE',
  SYS_MENU_VIEW = 'SYS_MENU_VIEW',
  SYS_MENU_ADD = 'SYS_MENU_ADD',
  SYS_MENU_UPDATE = 'SYS_MENU_UPDATE',
  SYS_MENU_DELETE = 'SYS_MENU_DELETE',
}

export const enum BizTypeGroupMenu {
  SYS_GROUP_MENU_LIST = 'SYS_GROUP_MENU_LIST',
  SYS_GROUP_MENU_VIEW = 'SYS_GROUP_MENU_VIEW',
  SYS_GROUP_MENU_ADD = 'SYS_GROUP_MENU_ADD',
  SYS_GROUP_MENU_UPDATE = 'SYS_GROUP_MENU_UPDATE',
  SYS_GROUP_MENU_DELETE = 'SYS_GROUP_MENU_DELETE',
  SYS_GROUP_MENU_ADD_LIST_MENU = 'SYS_GROUP_MENU_ADD_LIST_MENU',
}

export const enum BizTypeFunction {
  SYS_FUNCTION_LIST = 'SYS_FUNCTION_LIST',
  SYS_FUNCTION_VIEW = 'SYS_FUNCTION_VIEW',
  SYS_FUNCTION_ADD = 'SYS_FUNCTION_ADD',
  SYS_FUNCTION_UPDATE = 'SYS_FUNCTION_UPDATE',
  SYS_FUNCTION_DELETE = 'SYS_FUNCTION_DELETE',
}

export const enum BizTypeGroupFunction {
  SYS_ROLE_LIST = 'SYS_ROLE_LIST',
  SYS_ROLE_ADD = 'SYS_ROLE_ADD',
  SYS_ROLE_UPDATE = 'SYS_ROLE_UPDATE',
  SYS_ROLE_VIEW = 'SYS_ROLE_VIEW',
  SYS_ROLE_DELETE = 'SYS_ROLE_DELETE',
}

export const enum BizTypeUser {
  SYS_AUTH_USER_LIST = 'SYS_AUTH_USER_LIST',
  SYS_AUTH_USER_VIEW = 'SYS_AUTH_USER_VIEW',
  SYS_AUTH_USER_ADD = 'SYS_AUTH_USER_ADD',
  SYS_AUTH_USER_UPDATE = 'SYS_AUTH_USER_UPDATE',
  SYS_AUTH_USER_DELETE = 'SYS_AUTH_USER_DELETE',
  SYS_AUTH_USER_ADD_LIST_ROLE = 'SYS_AUTH_USER_ADD_LIST_ROLE',
  SYS_AUTH_USER_ADD_GROUP_MENU = 'SYS_AUTH_USER_ADD_GROUP_MENU',
  SYS_AUTH_USER_ADD_LIST_ORGANIZ = 'SYS_AUTH_USER_ADD_LIST_ORGANIZ',
}

export const enum BizTypeSyncForeignReferenceConfig {
  SYNCFOREIGNREFERENCECONFIG_LIST = 'SYNCFOREIGNREFERENCECONFIG_LIST',
  SYNCFOREIGNREFERENCECONFIG_GET_BY_ID = 'SYNCFOREIGNREFERENCECONFIG_GET_BY_ID',
  SYNCFOREIGNREFERENCECONFIG_ADD = 'SYNCFOREIGNREFERENCECONFIG_ADD',
  SYNCFOREIGNREFERENCECONFIG_UPDATE = 'SYNCFOREIGNREFERENCECONFIG_UPDATE',
  SYNCFOREIGNREFERENCECONFIG_DELETE = 'SYNCFOREIGNREFERENCECONFIG_DELETE',
}

export const enum BizTypeCountry {
  COUNTRY_LIST = 'COUNTRY_LIST',
  COUNTRY_GET_BY_ID = 'COUNTRY_GET_BY_ID',
  COUNTRY_ADD = 'COUNTRY_ADD',
  COUNTRY_UPDATE = 'COUNTRY_UPDATE',
  COUNTRY_DELETE = 'COUNTRY_DELETE',
  COUNTRY_LIST_NOPAGING = 'COUNTRY_LIST_NOPAGING',
}

export const enum BizTypeProvince {
  PROVINCE_LIST = 'PROVINCE_LIST',
  PROVINCE_GET_BY_ID = 'PROVINCE_GET_BY_ID',
  PROVINCE_ADD = 'PROVINCE_ADD',
  PROVINCE_UPDATE = 'PROVINCE_UPDATE',
  PROVINCE_DELETE = 'PROVINCE_DELETE',
  PROVINCE_LIST_NOPAGING = 'PROVINCE_LIST_NOPAGING',
}

export const enum BizTypeCatalog {
  CATALOG_LIST = 'CATALOG_LIST',
  CATALOG_GET_BY_ID = 'CATALOG_GET_BY_ID',
  CATALOG_LIST_NOPAGING = 'CATALOG_LIST_NOPAGING',
  CATALOG_ADD = 'CATALOG_ADD',
  CATALOG_UPDATE = 'CATALOG_UPDATE',
  CATALOG_DELETE = 'CATALOG_DELETE',
  CATALOG_GET_BY_CODE = 'CATALOG_GET_BY_CODE',
  CATALOG_EXPORT_EXCEL = 'CATALOG_EXPORT_EXCEL',
}

export const enum BizTypeCatalogType {
  CATALOG_TYPE_LIST = 'CATALOGTYPE_LIST',
  CATALOG_TYPE_GET_BY_ID = 'CATALOGTYPE_GET_BY_ID',
  CATALOG_TYPE_LIST_NOPAGING = 'CATALOGTYPE_LIST_NOPAGING',
  CATALOG_TYPE_ADD = 'CATALOGTYPE_ADD',
  CATALOG_TYPE_UPDATE = 'CATALOGTYPE_UPDATE',
  CATALOG_TYPE_DELETE = 'CATALOGTYPE_DELETE',
  CATALOG_TYPE_GET_BY_CODE = 'CATALOGTYPE_GET_BY_CODE',
}

export const enum BizTypeOrganization {
  ORGANIZATION_LIST = 'ORGANIZATION_LIST',
  ORGANIZATION_LIST_NOPAGING = 'ORGANIZATION_LIST_NOPAGING',
  ORGANIZATION_GET_BY_ID = 'ORGANIZATION_GET_BY_ID',
  ORGANIZATION_ADD = 'ORGANIZATION_ADD',
  ORGANIZATION_EXPORT_EXCEL = 'ORGANIZATION_EXPORT_EXCEL',
  ORGANIZATION_UPDATE = 'ORGANIZATION_UPDATE',
  ORGANIZATION_DELETE = 'ORGANIZATION_DELETE',
  ORGANIZATION_SEARCH_BY_TREE_NOPAGING = 'Organization_SEARCH_BY_TREE_NOPAGING',
}
export const enum BizTypeDynamicForm {
  DYNAMIC_FORM_CONFIG_LIST = 'DYNAMIC_FORM_CONFIG_LIST',
  DYNAMIC_FORM_CONFIG_VIEW = 'DYNAMIC_FORM_CONFIG_VIEW',
  DYNAMIC_FORM_CONFIG_ADD = 'DYNAMIC_FORM_CONFIG_ADD',
  DYNAMIC_FORM_CONFIG_UPDATE = 'DYNAMIC_FORM_CONFIG_UPDATE',
  DYNAMIC_FORM_CONFIG_DELETE = 'DYNAMIC_FORM_CONFIG_DELETE',
}

export const enum BizTypeKios {
  CAY_LAY_SO_SELECT_LIST = 'CAY_LAY_SO_SELECT_LIST',
  KIOSK_KHAOSAT_ADD = 'KIOSK_KHAOSAT_ADD',
  CAY_LAY_SO_ADD = 'CAY_LAY_SO_ADD',
  KIOSK_DICHVU_CHITIEU_SELECT = 'KIOSK_DICHVU_CHITIEU_SELECT',
  KIOSK_NGUONKHACH_SELECT = 'KIOSK_NGUONKHACH_SELECT',
  KIOSK_NGHENGHIEP_SELECT = 'KIOSK_NGHENGHIEP_SELECT',
  KIOSK_PHONGKHAM_SELECT = 'KIOSK_PHONGKHAM_SELECT',
  KIOSK_KETQUA_SELECT = 'HIS/KIOT/ThongTinKCB?SoVaoVien=',
  KIOSK_CONFIG_SELECT = 'KIOSK_CONFIG_SELECT',
  KIOSK_BENHNHAN_SELECT = 'KIOSK_BENHNHAN_SELECT',
  KIOSK_BENHNHAN_UPDATE_MABENHNHAN = 'KIOSK_BENHNHAN_UPDATE_MABENHNHAN',
  KIOSK_BENHNHAN_ADD = 'KIOSK_BENHNHAN_ADD',
  KIOSK_BENHNHAN_REPORT = 'KIOSK_BENHNHAN_REPORT',
  KIOSK_THONG_TIN_SO_SELECT = 'HIS/KIOT/ThongTinHoSo?SoTheBHYT=',
  KIOSK_DANGKY_KHAM = 'HIS/KIOT/DangKyKham',
}

export const enum BizTypeCompany {
  COMPANY_LIST = 'COMPANY_LIST',
  COMPANY_GET_BY_ID = 'COMPANY_GET_BY_ID',
  COMPANY_ADD = 'COMPANY_ADD',
  COMPANY_UPDATE = 'COMPANY_UPDATE',
  COMPANY_DELETE = 'COMPANY_DELETE',
  COMPANY_EXPORT_EXCEL = 'COMPANY_EXPORT_EXCEL',
}

export const enum BizTypeICDTM {
  ICDTM_LIST = 'ICDTM_LIST',
  ICDTM_GET_BY_ID = 'ICDTM_GET_BY_ID',
  ICDTM_ADD = 'ICDTM_ADD',
  ICDTM_UPDATE = 'ICDTM_UPDATE',
  ICDTM_DELETE = 'ICDTM_DELETE',
  ICDTM_EXPORT_EXCEL = 'ICDTM_EXPORT_EXCEL',
  ICDTM_IMPORT_EXCEL = 'ICDTM_IMPORT_EXCEL',
}

export const enum BizTypeIcd10 {
  ICD10Directory_LIST = 'ICD10Directory_LIST',
  ICD10Directory_LIST_NOPAGING = 'ICD10Directory_LIST_NOPAGING',
  ICD10Directory_GET_BY_ID = 'ICD10Directory_GET_BY_ID',
  ICD10Directory_CREATE = 'ICD10Directory_ADD',
  ICD10Directory_UPDATE = 'ICD10Directory_UPDATE',
  ICD10Directory_DELETE = 'ICD10Directory_DELETE',
  ICD10Directory_EXPORT_EXCEL = 'ICD10Directory_EXPORT_EXCEL',
}

export const enum BizTypeSysBizType {
  SYS_BIZ_TYPE_LIST = 'SYS_BIZ_TYPE_LIST',
  SYS_BIZ_TYPE_GET_BY_ID = 'SYS_BIZ_TYPE_GET_BY_ID',
  SYS_BIZ_TYPE_ADD = 'SYS_BIZ_TYPE_ADD',
  SYS_BIZ_TYPE_UPDATE = 'SYS_BIZ_TYPE_UPDATE',
  SYS_BIZ_TYPE_DELETE = 'SYS_BIZ_TYPE_DELETE',
}

export const enum BizTypeSysDatabase {
  SYS_DATABASE_LIST = 'SYS_DATABASE_LIST',
}

export const enum BizTypeIcd9cm {
  ICD9CM_LIST = 'ICD9CM_LIST',
  ICD9CM_GET_BY_ID = 'ICD9CM_GET_BY_ID',
  ICD9CM_CREATE = 'ICD9CM_ADD',
  ICD9CM_UPDATE = 'ICD9CM_UPDATE',
  ICD9CM_DELETE = 'ICD9CM_DELETE',
  ICD9CM_EXPORT_EXCEL = 'ICD9CM_EXPORT_EXCEL',
}

export const enum BizTypeManufacturer {
  MANUFACTURER_LIST = 'MANUFACTURER_LIST',
  MANUFACTURER_GET_BY_ID = 'MANUFACTURER_GET_BY_ID',
  MANUFACTURER_CREATE = 'MANUFACTURER_ADD',
  MANUFACTURER_UPDATE = 'MANUFACTURER_UPDATE',
  MANUFACTURER_DELETE = 'MANUFACTURER_DELETE',
  MANUFACTURER_EXPORT_EXCEL = 'MANUFACTURER_EXPORT_EXCEL',
}

export const enum BizTypeProcedureMethod {
  PROCEDURE_METHOD_LIST = 'PROCEDUREMETHOD_LIST',
  PROCEDURE_METHOD_GET_BY_ID = 'PROCEDUREMETHOD_GET_BY_ID',
  PROCEDURE_METHOD_CREATE = 'PROCEDUREMETHOD_ADD',
  PROCEDURE_METHOD_UPDATE = 'PROCEDUREMETHOD_UPDATE',
  PROCEDURE_METHOD_DELETE = 'PROCEDUREMETHOD_DELETE',
  PROCEDURE_METHOD_EXPORT_EXCEL = 'PROCEDUREMETHOD_EXPORT_EXCEL',
}

export const enum BizTypeProcedureNote {
  PROCEDURE_NOTE_LIST = 'PROCEDURENOTE_LIST',
  PROCEDURE_NOTE_GET_BY_ID = 'PROCEDURENOTE_GET_BY_ID',
  PROCEDURE_NOTE_CREATE = 'PROCEDURENOTE_ADD',
  PROCEDURE_NOTE_UPDATE = 'PROCEDURENOTE_UPDATE',
  PROCEDURE_NOTE_DELETE = 'PROCEDURENOTE_DELETE',
  PROCEDURE_NOTE_EXPORT_EXCEL = 'PROCEDURENOTE_EXPORT_EXCEL',
}

export const enum BizTypeSickBed {
  SICK_BED_LIST = 'SICKBED_LIST',
  SICK_BED_GET_BY_ID = 'SICKBED_GET_BY_ID',
  SICK_BED_CREATE = 'SICKBED_ADD',
  SICK_BED_UPDATE = 'SICKBED_UPDATE',
  SICK_BED_DELETE = 'SICKBED_DELETE',
  SICK_BED_EXPORT_EXCEL = 'SICKBED_EXPORT_EXCEL',
}

export const enum BizTypeReferenceRange {
  REFERENCE_RANGE_LIST = 'REFERENCERANGE_LIST',
  REFERENCE_RANGE_GET_BY_ID = 'REFERENCERANGE_GET_BY_ID',
  REFERENCE_RANGE_CREATE = 'REFERENCERANGE_ADD',
  REFERENCE_RANGE_UPDATE = 'REFERENCERANGE_UPDATE',
  REFERENCE_RANGE_DELETE = 'REFERENCERANGE_DELETE',
  REFERENCE_RANGE_EXPORT_EXCEL = 'REFERENCERANGE_EXPORT_EXCEL',
}

export const enum BizTypeTemplateOutcome {
  TEMPLATE_OUTCOME_LIST = 'TEMPLATEOUTCOME_LIST',
  TEMPLATE_OUTCOME_LIST_NOPAGING = 'TEMPLATEOUTCOME_LIST_NOPAGING',
  TEMPLATE_OUTCOME_GET_BY_ID = 'TEMPLATEOUTCOME_GET_BY_ID',
  TEMPLATE_OUTCOME_CREATE = 'TEMPLATEOUTCOME_ADD',
  TEMPLATE_OUTCOME_UPDATE = 'TEMPLATEOUTCOME_UPDATE',
  TEMPLATE_OUTCOME_DELETE = 'TEMPLATEOUTCOME_DELETE',
  TEMPLATE_OUTCOME_EXPORT_EXCEL = 'TEMPLATEOUTCOME_EXPORT_EXCEL',
}

export const enum BizTypePractitioner {
  PRACTITIONER_LIST = 'PRACTITIONER_LIST',
  PRACTITIONER_GET_BY_ID = 'PRACTITIONER_GET_BY_ID',
  PRACTITIONER_ADD = 'PRACTITIONER_ADD',
  PRACTITIONER_UPDATE = 'PRACTITIONER_UPDATE',
  PRACTITIONER_DELETE = 'PRACTITIONER_DELETE',
  PRACTITIONER_EXPORT_EXCEL = 'PRACTITIONER_EXPORT_EXCEL',
  PRACTITIONER_LIST_NOPAGING = 'PRACTITIONER_LIST_NOPAGING',
}

export const enum BizTypeLocation {
  LOCATION_LIST = 'LOCATION_LIST',
  LOCATION_LIST_NOPAGING = 'LOCATION_LIST_NOPAGING',
  LOCATION_GET_BY_ID = 'LOCATION_GET_BY_ID',
  LOCATION_ADD = 'LOCATION_ADD',
  LOCATION_UPDATE = 'LOCATION_UPDATE',
  LOCATION_DELETE = 'LOCATION_DELETE',
  LOCATION_EXPORT_EXCEL = 'LOCATION_EXPORT_EXCEL',
  CARE_DB_LOCATION_LIST = 'CARE_DB_LOCATION_LIST', 
}

export const enum BizTypeIngredient {
  INGREDIENT_LIST = 'INGREDIENT_LIST',
  INGREDIENT_LIST_NOPAGING = 'INGREDIENT_LIST_NOPAGING',
  INGREDIENT_GET_BY_ID = 'INGREDIENT_GET_BY_ID',
  INGREDIENT_ADD = 'INGREDIENT_ADD',
  INGREDIENT_UPDATE = 'INGREDIENT_UPDATE',
  INGREDIENT_DELETE = 'INGREDIENT_DELETE',
  INGREDIENT_EXPORT_EXCEL = 'INGREDIENT_EXPORT_EXCEL',
}

export const enum BizTypeBloodProduct {
  BLOODPRODUCT_LIST = 'BLOODPRODUCT_LIST',
  BLOODPRODUCT_LIST_NOPAGING = 'BLOODPRODUCT_LIST_NOPAGING',
  BLOODPRODUCT_GET_BY_ID = 'BLOODPRODUCT_GET_BY_ID',
  BLOODPRODUCT_ADD = 'BLOODPRODUCT_ADD',
  BLOODPRODUCT_UPDATE = 'BLOODPRODUCT_UPDATE',
  BLOODPRODUCT_DELETE = 'BLOODPRODUCT_DELETE',
  BLOODPRODUCT_EXPORT_EXCEL = 'BLOODPRODUCT_EXPORT_EXCEL',
}

export const enum BizTypeBonusPoint {
  BONUSPOINT_LIST = 'BONUSPOINT_LIST',
  BONUSPOINT_LIST_NOPAGING = 'BONUSPOINT_LIST_NOPAGING',
  BONUSPOINT_GET_BY_ID = 'BONUSPOINT_GET_BY_ID',
  BONUSPOINT_ADD = 'BONUSPOINT_ADD',
  BONUSPOINT_UPDATE = 'BONUSPOINT_UPDATE',
  BONUSPOINT_DELETE = 'BONUSPOINT_DELETE',
  BONUSPOINT_EXPORT_EXCEL = 'BONUSPOINT_EXPORT_EXCEL',
}

export const enum BizTypeMedicationGroup {
  MEDICATIONGROUP_LIST = 'MEDICATIONGROUP_LIST',
  MEDICATIONGROUP_LIST_NOPAGING = 'MEDICATIONGROUP_LIST_NOPAGING',
  MEDICATIONGROUP_GET_BY_ID = 'MEDICATIONGROUP_GET_BY_ID',
  MEDICATIONGROUP_ADD = 'MEDICATIONGROUP_ADD',
  MEDICATIONGROUP_UPDATE = 'MEDICATIONGROUP_UPDATE',
  MEDICATIONGROUP_DELETE = 'MEDICATIONGROUP_DELETE',
  MEDICATIONGROUP_EXPORT_EXCEL = 'MEDICATIONGROUP_EXPORT_EXCEL',
}

export const enum BizTypeMedication {
  MEDICATION_LIST = 'MEDICATION_LIST',
  MEDICATION_LIST_NOPAGING = 'MEDICATION_LIST_NOPAGING',
  MEDICATION_GET_BY_ID = 'MEDICATION_GET_BY_ID',
  MEDICATION_ADD = 'MEDICATION_ADD',
  MEDICATION_UPDATE = 'MEDICATION_UPDATE',
  MEDICATION_DELETE = 'MEDICATION_DELETE',
  MEDICATION_EXPORT_EXCEL = 'MEDICATION_EXPORT_EXCEL',
}

export const enum BizTypeMedicationType {
  MEDICATIONTYPE_LIST = 'MEDICATIONTYPE_LIST',
  MEDICATIONTYPE_LIST_NOPAGING = 'MEDICATIONTYPE_LIST_NOPAGING',
  MEDICATIONTYPE_GET_BY_ID = 'MEDICATIONTYPE_GET_BY_ID',
  MEDICATIONTYPE_ADD = 'MEDICATIONTYPE_ADD',
  MEDICATIONTYPE_UPDATE = 'MEDICATIONTYPE_UPDATE',
  MEDICATIONTYPE_DELETE = 'MEDICATIONTYPE_DELETE',
}

export const enum BizTypeMedicationWarning {
  MEDICATIONWARNING_LIST = 'MEDICATIONWARNING_LIST',
  MEDICATIONWARNING_LIST_NOPAGING = 'MEDICATIONWARNING_LIST_NOPAGING',
  MEDICATIONWARNING_GET_BY_ID = 'MEDICATIONWARNING_GET_BY_ID',
  MEDICATIONWARNING_ADD = 'MEDICATIONWARNING_ADD',
  MEDICATIONWARNING_UPDATE = 'MEDICATIONWARNING_UPDATE',
  MEDICATIONWARNING_DELETE = 'MEDICATIONWARNING_DELETE',
  MEDICATIONWARNING_EXPORT_EXCEL = 'MEDICATIONWARNING_EXPORT_EXCEL',
}

export const enum BizTypeMedicationPack {
  MEDICATIONPACK_LIST = 'MEDICATIONPACK_LIST',
  MEDICATIONPACK_LIST_NOPAGING = 'MEDICATIONPACK_LIST_NOPAGING',
  MEDICATIONPACK_GET_BY_ID = 'MEDICATIONPACK_GET_BY_ID',
  MEDICATIONPACK_ADD = 'MEDICATIONPACK_ADD',
  MEDICATIONPACK_UPDATE = 'MEDICATIONPACK_UPDATE',
  MEDICATIONPACK_DELETE = 'MEDICATIONPACK_DELETE',
}

export const enum BizTypeMedicationPackDetail {
  MEDICATIONPACKDETAIL_LIST = 'MEDICATIONPACKDETAIL_LIST',
  MEDICATIONPACKDETAIL_LIST_NOPAGING = 'MEDICATIONPACKDETAIL_LIST_NOPAGING',
  MEDICATIONPACKDETAIL_GET_BY_ID = 'MEDICATIONPACKDETAIL_GET_BY_ID',
  MEDICATIONPACKDETAIL_ADD = 'MEDICATIONPACKDETAIL_ADD',
  MEDICATIONPACKDETAIL_UPDATE = 'MEDICATIONPACKDETAIL_UPDATE',
  MEDICATIONPACKDETAIL_DELETE = 'MEDICATIONPACKDETAIL_DELETE',
}

export const enum BizTypeMemberRanking {
  MEMBER_RANKING_LIST = 'MEMBER_RANKING_LIST',
  MEMBER_RANKING_LIST_NOPAGING = 'MEMBER_RANKING_LIST_NOPAGING',
  MEMBER_RANKING_GET_BY_ID = 'MEMBER_RANKING_GET_BY_ID',
  MEMBER_RANKING_CREATE = 'MEMBER_RANKING_ADD',
  MEMBER_RANKING_UPDATE = 'MEMBER_RANKING_UPDATE',
  MEMBER_RANKING_DELETE = 'MEMBER_RANKING_DELETE',
  MEMBER_RANKING_SEARCH = 'MEMBER_RANKING_LIST',
  MEMBER_RANKING_EXPORT_EXCEL = 'MEMBER_RANKING_EXPORT_EXCEL',
}

export const enum BizTypeInsuranceHospital {
  INSURANCE_HOSPITAL_LIST = 'INSURANCEHOSPITAL_LIST',
  INSURANCE_HOSPITAL_LIST_NOPAGING = 'INSURANCEHOSPITAL_LIST_NOPAGING',
  INSURANCE_HOSPITAL_GET_BY_ID = 'INSURANCEHOSPITAL_GET_BY_ID',
  INSURANCE_HOSPITAL_CREATE = 'INSURANCEHOSPITAL_ADD',
  INSURANCE_HOSPITAL_UPDATE = 'INSURANCEHOSPITAL_UPDATE',
  INSURANCE_HOSPITAL_DELETE = 'INSURANCEHOSPITAL_DELETE',
  INSURANCE_HOSPITAL_EXPORT_EXCEL = 'INSURANCEHOSPITAL_EXPORT_EXCEL',
}

export const enum BizTypeServiceType {
  SERVICETYPE_LIST = 'SERVICETYPE_LIST',
  SERVICETYPE_LIST_NOPAGING = 'SERVICETYPE_LIST_NOPAGING',
  SERVICETYPE_GET_BY_ID = 'SERVICETYPE_GET_BY_ID',
  SERVICETYPE_ADD = 'SERVICETYPE_ADD',
  SERVICETYPE_UPDATE = 'SERVICETYPE_UPDATE',
  SERVICETYPE_DELETE = 'SERVICETYPE_DELETE',
  SERVICETYPE_EXPORT_EXCEL = 'SERVICETYPE_EXPORT_EXCEL',
}

export const enum BizTypeServiceGroup {
  SERVICEGROUP_LIST = 'SERVICEGROUP_LIST',
  SERVICEGROUP_LIST_NOPAGING = 'SERVICEGROUP_LIST_NOPAGING',
  SERVICEGROUP_GET_BY_ID = 'SERVICEGROUP_GET_BY_ID',
  SERVICEGROUP_ADD = 'SERVICEGROUP_ADD',
  SERVICEGROUP_UPDATE = 'SERVICEGROUP_UPDATE',
  SERVICEGROUP_DELETE = 'SERVICEGROUP_DELETE',
}

export const enum BizTypeCost {
  COST_LIST = 'COST_LIST',
  COST_GET_BY_ID = 'COST_GET_BY_ID',
  COST_CREATE = 'COST_ADD',
  COST_UPDATE = 'COST_UPDATE',
  COST_DELETE = 'COST_DELETE',
  COST_EXPORT_EXCEL = 'COST_EXPORT_EXCEL',
}

export const enum BizTypeCostPeriod {
  COSTPERIOD_LIST = 'COST_PERIOD_LIST',
  COSTPERIOD_GET_BY_ID = 'COST_PERIOD_GET_BY_ID',
  COSTPERIOD_CREATE = 'COST_PERIOD_ADD',
  COSTPERIOD_UPDATE = 'COST_PERIOD_UPDATE',
  COSTPERIOD_DELETE = 'COST_PERIOD_DELETE',
  COSTPERIOD_EXPORT_EXCEL = 'COST_PERIOD_EXPORT_EXCEL',
}

export const enum BizTypeService {
  SERVICE_LIST = 'SERVICE_LIST',
  SERVICE_LIST_NOPAGING = 'SERVICE_LIST_NOPAGING',
  SERVICE_GET_BY_ID = 'SERVICE_GET_BY_ID',
  SERVICE_ADD = 'SERVICE_ADD',
  SERVICE_UPDATE = 'SERVICE_UPDATE',
  SERVICE_DELETE = 'SERVICE_DELETE',
  SERVICE_EXPORT_EXCEL = 'SERVICE_EXPORT_EXCEL',
}

export const enum BizTypeDrugInteraction {
  DRUGINTERACTION_ADD = 'DRUGINTERACTION_ADD',
  DRUGINTERACTION_UPDATE = 'DRUGINTERACTION_UPDATE',
  DRUGINTERACTION_DELETE = 'DRUGINTERACTION_DELETE',
  DRUGINTERACTION_LIST = 'DRUGINTERACTION_LIST',
  DRUGINTERACTION_LIST_NOPAGING = 'DRUGINTERACTION_LIST_NOPAGING',
  DRUGINTERACTION_GET_BY_ID = 'DRUGINTERACTION_GET_BY_ID',
  DRUGINTERACTION_EXPORT_EXCEL = 'DRUGINTERACTION_EXPORT_EXCEL',
}

export const enum BizTypeEInvoiceContent {
  EINVOICECONTENT_LIST = 'EINVOICECONTENT_LIST',
  EINVOICECONTENT_LIST_NOPAGING = 'EINVOICECONTENT_LIST_NOPAGING',
  EINVOICECONTENT_GET_BY_ID = 'EINVOICECONTENT_GET_BY_ID',
  EINVOICECONTENT_ADD = 'EINVOICECONTENT_ADD',
  EINVOICECONTENT_UPDATE = 'EINVOICECONTENT_UPDATE',
  EINVOICECONTENT_DELETE = 'EINVOICECONTENT_DELETE',
  EINVOICECONTENT_EXPORT_EXCEL = 'EINVOICECONTENT_EXPORT_EXCEL',
}

export const enum BizTypeMedicationTraditionalProcessing {
  MEDICATIONTRADITIONALPROCESSING_LIST = 'MEDICATIONTRADITIONALPROCESSING_LIST',
  MEDICATIONTRADITIONALPROCESSING_LIST_NOPAGING = 'MEDICATIONTRADITIONALPROCESSING_LIST_NOPAGING',
  MEDICATIONTRADITIONALPROCESSING_GET_BY_ID = 'MEDICATIONTRADITIONALPROCESSING_GET_BY_ID',
  MEDICATIONTRADITIONALPROCESSING_ADD = 'MEDICATIONTRADITIONALPROCESSING_ADD',
  MEDICATIONTRADITIONALPROCESSING_UPDATE = 'MEDICATIONTRADITIONALPROCESSING_UPDATE',
  MEDICATIONTRADITIONALPROCESSING_DELETE = 'MEDICATIONTRADITIONALPROCESSING_DELETE',
  MEDICATIONTRADITIONALPROCESSING_EXPORT_EXCEL = 'MEDICATIONTRADITIONALPROCESSING_EXPORT_EXCEL',
}

export const enum BizTypeOccupation {
  OCCUPATION_LIST = 'OCCUPATION_LIST',
  OCCUPATION_LIST_NOPAGING = 'OCCUPATION_LIST_NOPAGING',
  OCCUPATION_GET_BY_ID = 'OCCUPATION_GET_BY_ID',
  OCCUPATION_ADD = 'OCCUPATION_ADD',
  OCCUPATION_UPDATE = 'OCCUPATION_UPDATE',
  OCCUPATION_DELETE = 'OCCUPATION_DELETE',
  OCCUPATION_EXPORT_EXCEL = 'OCCUPATION_EXPORT_EXCEL',
}

export const enum BizTypeCurrencyExchangeRate {
  CURRENCYEXCHANGERATE_LIST = 'CURRENCYEXCHANGERATE_LIST',
  CURRENCYEXCHANGERATE_LIST_NOPAGING = 'CURRENCYEXCHANGERATE_LIST_NOPAGING',
  CURRENCYEXCHANGERATE_GET_BY_ID = 'CURRENCYEXCHANGERATE_GET_BY_ID',
  CURRENCYEXCHANGERATE_ADD = 'CURRENCYEXCHANGERATE_ADD',
  CURRENCYEXCHANGERATE_UPDATE = 'CURRENCYEXCHANGERATE_UPDATE',
  CURRENCYEXCHANGERATE_DELETE = 'CURRENCYEXCHANGERATE_DELETE',
  CURRENCYEXCHANGERATE_EXPORT_EXCEL = 'CURRENCYEXCHANGERATE_EXPORT_EXCEL',
}

export const enum BizTypeReferral {
  REFERRAL_LIST = 'REFERRAL_LIST',
  REFERRAL_LIST_NOPAGING = 'REFERRAL_LIST_NOPAGING',
  REFERRAL_GET_BY_ID = 'REFERRAL_GET_BY_ID',
  REFERRAL_ADD = 'REFERRAL_ADD',
  REFERRAL_UPDATE = 'REFERRAL_UPDATE',
  REFERRAL_DELETE = 'REFERRAL_DELETE',
  REFERRAL_EXPORT_EXCEL = 'REFERRAL_EXPORT_EXCEL',
}

export const enum BizTypeTreatmentRecord {
  TREATMENTRECORD_LIST = 'TREATMENTRECORD_LIST',
  TREATMENTRECORD_LIST_NOPAGING = 'TREATMENTRECORD_LIST_NOPAGING',
  TREATMENTRECORD_GET_BY_ID = 'TREATMENTRECORD_GET_BY_ID',
  TREATMENTRECORD_ADD = 'TREATMENTRECORD_ADD',
  TREATMENTRECORD_UPDATE = 'TREATMENTRECORD_UPDATE',
  TREATMENTRECORD_DELETE = 'TREATMENTRECORD_DELETE',
  TREATMENTRECORD_EXPORT_EXCEL = 'TREATMENTRECORD_EXPORT_EXCEL',
}

export const enum BizTypCommonExport {
  COMMON_EXPORT_EXCEL = 'COMMON_EXPORT_EXCEL',
}

export const enum BizTypeServicePack {
  SERVICEPACK_LIST = 'SERVICEPACK_LIST',
  SERVICEPACK_LIST_NOPAGING = 'SERVICEPACK_LIST_NOPAGING',
  SERVICEPACK_GET_BY_ID = 'SERVICEPACK_GET_BY_ID',
  SERVICEPACK_ADD = 'SERVICEPACK_ADD',
  SERVICEPACK_UPDATE = 'SERVICEPACK_UPDATE',
  SERVICEPACK_DELETE = 'SERVICEPACK_DELETE',
  SERVICEPACK_EXPORT_EXCEL = 'SERVICEPACK_EXPORT_EXCEL',
}

export const enum BizTypeServicePackDetail {
  SERVICEPACKDETAIL_LIST = 'SERVICEPACKDETAIL_LIST',
  SERVICEPACKDETAIL_LIST_NOPAGING = 'SERVICEPACKDETAIL_LIST_NOPAGING',
  SERVICEPACKDETAIL_GET_BY_ID = 'SERVICEPACKDETAIL_GET_BY_ID',
  SERVICEPACKDETAIL_ADD = 'SERVICEPACKDETAIL_ADD',
  SERVICEPACKDETAIL_UPDATE = 'SERVICEPACKDETAIL_UPDATE',
  SERVICEPACKDETAIL_DELETE = 'SERVICEPACKDETAIL_DELETE',
  SERVICEPACKDETAIL_EXPORT_EXCEL = 'SERVICEPACKDETAIL_EXPORT_EXCEL',
}

export const enum BizTypeSupplier {
  SUPPLIER_LIST = 'SUPPLIER_LIST',
  SUPPLIER_LIST_NOPAGING = 'SUPPLIER_LIST_NOPAGING',
  SUPPLIER_GET_BY_ID = 'SUPPLIER_GET_BY_ID',
  SUPPLIER_ADD = 'SUPPLIER_ADD',
  SUPPLIER_UPDATE = 'SUPPLIER_UPDATE',
  SUPPLIER_DELETE = 'SUPPLIER_DELETE',
  SUPPLIER_EXPORT_EXCEL = 'SUPPLIER_EXPORT_EXCEL',
}

export const enum BizTypeSubService {
  SUBSERVICE_LIST = 'SUBSERVICE_LIST',
  SUBSERVICE_LIST_NOPAGING = 'SUBSERVICE_LIST_NOPAGING',
  SUBSERVICE_GET_BY_ID = 'SUBSERVICE_GET_BY_ID',
  SUBSERVICE_ADD = 'SUBSERVICE_ADD',
  SUBSERVICE_UPDATE = 'SUBSERVICE_UPDATE',
  SUBSERVICE_DELETE = 'SUBSERVICE_DELETE',
  SUBSERVICE_EXPORT_EXCEL = 'SUBSERVICE_EXPORT_EXCEL',
}

export const enum BizTypeLocationServiceSetting {
  LOCATIONSERVICESETTING_LIST = 'LOCATIONSERVICESETTING_LIST',
  LOCATIONSERVICESETTING_LIST_NOPAGING = 'LOCATIONSERVICESETTING_LIST_NOPAGING',
  LOCATIONSERVICESETTING_GET_BY_ID = 'LOCATIONSERVICESETTING_GET_BY_ID',
  LOCATIONSERVICESETTING_ADD = 'LOCATIONSERVICESETTING_ADD',
  LOCATIONSERVICESETTING_UPDATE = 'LOCATIONSERVICESETTING_UPDATE',
  LOCATIONSERVICESETTING_DELETE = 'LOCATIONSERVICESETTING_DELETE',
  LOCATIONSERVICESETTING_EXPORT_EXCEL = 'LOCATIONSERVICESETTING_EXPORT_EXCEL',
}

export const enum BizTypeMasterDataSyncConfig {
  MASTERDATASYNCCONFIG_LIST = 'MASTERDATASYNCCONFIG_LIST',
}

export const enum BizTypeMasterDataExchange {
  MASTERDATAEXCHANGE_EXPORT = 'MASTERDATAEXCHANGE_EXPORT',
  MASTERDATAEXCHANGE_IMPORT = 'MASTERDATAEXCHANGE_IMPORT',
  FOREIGNREFERENCE_IMPORT = 'FOREIGNREFERENCE_IMPORT',
}

export const enum BizTypePatient {
  PATIENT_LIST = 'PATIENT_LIST',
  PATIENT_LIST_NOPAGING = 'PATIENT_LIST_NOPAGING',
  PATIENT_REFERENCE_LIST = 'PATIENT_REFERENCE_LIST',
  PATIENT_GET_BY_ID = 'PATIENT_GET_BY_ID',
  PATIENT_ADD = 'PATIENT_ADD',
  PATIENT_UPDATE = 'PATIENT_UPDATE',
  PATIENT_DELETE = 'PATIENT_DELETE',
  PATIENT_EXPORT_EXCEL = 'PATIENT_EXPORT_EXCEL',
  PATIENT_QUERY_KEY_LIST = 'PATIENT_QUERY_KEY_LIST',
}

export const enum BizTypeComposition {
  COMPOSITION_LIST = 'COMPOSITION_LIST',
  COMPOSITION_LIST_NOPAGING = 'COMPOSITION_LIST_NOPAGING',
  COMPOSITION_GET_BY_ID = 'COMPOSITION_GET_BY_ID',
  COMPOSITION_ADD = 'COMPOSITION_ADD',
  COMPOSITION_UPDATE = 'COMPOSITION_UPDATE',
  COMPOSITION_DELETE = 'COMPOSITION_DELETE',
  COMPOSITION_EXPORT_EXCEL = 'COMPOSITION_EXPORT_EXCEL',
}

export const enum BizTypeParaConfig {
  PARACONFIG_LIST = 'PARACONFIG_LIST',
  PARACONFIG_LIST_NOPAGING = 'PARACONFIG_LIST_NOPAGING',
  PARACONFIG_GET_BY_ID = 'PARACONFIG_GET_BY_ID',
  PARACONFIG_ADD = 'PARACONFIG_ADD',
  PARACONFIG_UPDATE = 'PARACONFIG_UPDATE',
  PARACONFIG_DELETE = 'PARACONFIG_DELETE',
  PARACONFIG_EXPORT_EXCEL = 'PARACONFIG_EXPORT_EXCEL',
}

export const enum BizTypeWard {
  WARD_LIST_NOPAGING = 'WARD_LIST_NOPAGING',
}

export const enum BizTypeReception {
  RECEPTION_LIST = 'RECEPTION_LIST',
  RECEPTION_ADD = 'RECEPTION_ADD',
  RECEPTION_UPDATE = 'RECEPTION_UPDATE',
  RECEPTION_DELETE = 'RECEPTION_DELETE',
  RECEPTION_GET_BY_ID = 'RECEPTION_GET_BY_ID',
}

export const enum BizTypeEncounter {
  ENCOUNTER_CLINIC_LIST = 'ENCOUNTER_CLINIC_LIST',
  ENCOUNTER_LIST = 'ENCOUNTER_LIST',
}
export const enum BizTypeServiceRequest {
  SERVICEREQUEST_LIST = 'SERVICEREQUEST_LIST',
  SERVICEREQUEST_LIST_NOPAGING = 'SERVICEREQUEST_LIST_NOPAGING',
  SERVICEREQUEST_GET_BY_ID = 'SERVICEREQUEST_GET_BY_ID',
  SERVICEREQUEST_ADD = 'SERVICEREQUEST_ADD',
  SERVICEREQUEST_UPDATE = 'SERVICEREQUEST_UPDATE',
  SERVICEREQUEST_DELETE = 'SERVICEREQUEST_DELETE',
}

export const enum BizTypeCompositionHistory {
  COMPOSITION_HISTORY_LIST = 'COMPOSITION_HISTORY_LIST',
}
export const enum BizTypePatientCDHA {
  PATIENT_CDHA_LIST = 'PATIENT_CDHA_LIST',
}
export const enum BizTypeProcedure {
  SURGERY_PROCEDURE_LIST='SURGERY_PROCEDURE_LIST'
}
export const enum BizTypeLogs {
  LIST = 'T_LOG_REQUEST',
  ITEM = 'T_LOG_REQUEST_BY_ID',
  ADD = 'T_LOG_REQUEST_ADD',
  UPDATE = 'T_LOG_REQUEST_UPDATE', 
  DELETE = 'T_LOG_REQUEST_DELETE'
}
export const enum BizTypeParaclinicalDiagnosticReport {
  PARACLINICAL_DIAGNOSTIC_REPORT_LIST = 'PARACLINICAL_DIAGNOSTIC_REPORT_LIST',
  PARACLINICAL_DIAGNOSTIC_REPORT_LIST_NOPAGING = 'PARACLINICAL_DIAGNOSTIC_REPORT_LIST_NOPAGING',
  PARACLINICAL_DIAGNOSTIC_REPORT_GET_BY_ID = 'PARACLINICAL_DIAGNOSTIC_REPORT_GET_BY_ID',
  PARACLINICAL_DIAGNOSTIC_REPORT_ADD = 'PARACLINICAL_DIAGNOSTIC_REPORT_ADD',
  PARACLINICAL_DIAGNOSTIC_REPORT_UPDATE = 'PARACLINICAL_DIAGNOSTIC_REPORT_UPDATE',
  PARACLINICAL_DIAGNOSTIC_REPORT_DELETE = 'PARACLINICAL_DIAGNOSTIC_REPORT_DELETE',
}
export const enum BizTypeParaclinicalImagingStudy {
  PARACLINICALIMAGINGSTUDY_ADD = 'PARACLINICALIMAGINGSTUDY_ADD',
  PARACLINICALIMAGINGSTUDY_UPDATE = 'PARACLINICALIMAGINGSTUDY_UPDATE',
  PARACLINICALIMAGINGSTUDY_DELETE = 'PARACLINICALIMAGINGSTUDY_DELETE',
  PARACLINICALIMAGINGSTUDY_LIST = 'PARACLINICALIMAGINGSTUDY_LIST',
  PARACLINICALIMAGINGSTUDY_LIST_NOPAGING = 'PARACLINICALIMAGINGSTUDY_LIST_NOPAGING',
  PARACLINICALIMAGINGSTUDY_GET_BY_ID = 'PARACLINICALIMAGINGSTUDY_GET_BY_ID',
}
export const enum BizTypeInventoryInputReceipt {
  api_inventory_input_receipt_list = 'api_inventory_input_receipt_list',
  INPUT_RECEIPT_GET_BY_ID = 'INPUT_RECEIPT_GET_BY_ID',
  INPUT_RECEIPT_ADD = 'INPUT_RECEIPT_ADD',
  INPUT_RECEIPT_UPDATE = 'INPUT_RECEIPT_UPDATE',
  INPUT_RECEIPT_DELETE = 'INPUT_RECEIPT_DELETE',
  api_inventory_get_list = 'api_inventory_get_list'}
